import React from "react"
import { useTranslation } from "react-i18next"

import { ConfirmationOverlay } from "shared/ui/confirmation-overlay/ConfirmationOverlay"

export interface SelectProductBaseVariantOverlayViewModel {
  closeOverlay: () => void
  selectPreset: () => void
}

export const SelectProductBaseVariantOverlayView = React.memo(
  ({
    closeOverlay,
    selectPreset
  }: SelectProductBaseVariantOverlayViewModel) => {
    const { t } = useTranslation()

    return (
      <ConfirmationOverlay.Root id="select-product-configuration-preset-overlay">
        <ConfirmationOverlay.Header>
          <ConfirmationOverlay.Title>
            {t("Product.Configuration.SelectBaseVariant")}
          </ConfirmationOverlay.Title>
        </ConfirmationOverlay.Header>
        <ConfirmationOverlay.Message>
          {t("Product.Configuration.SelectBaseVariantConfirmation")}
        </ConfirmationOverlay.Message>
        <ConfirmationOverlay.Actions>
          <ConfirmationOverlay.Cancel onClick={closeOverlay} />
          <ConfirmationOverlay.Submit onClick={selectPreset}>
            {t("General.Confirm")}
          </ConfirmationOverlay.Submit>
        </ConfirmationOverlay.Actions>
      </ConfirmationOverlay.Root>
    )
  }
)
